var MATCH = require('./_wks')('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/modules/_fails-is-regexp.js
// module id = ../../../../core-js/modules/_fails-is-regexp.js
// module chunks = 13